import { FaCheckCircle } from 'react-icons/fa';
import "./WeOffer.css";

function WeOffer({ data }) {
  return (
    <section
      className="we-offer"
      aria-label={`Why Choose: ${data.title} ${data.title_h}`}
    >
      <div className="we-offer-content">

        {data.title_s && (
          <p className="case-title">{data.title_s}</p>
        )}

        <h2 className="case-title-p">
          {data.title} <span>{data.title_h}</span>
        </h2>

        <p className="we-offer-description">
          {data.description}
        </p>

        <ul
          className="pricing-card-lists"
          aria-label={`List of features for ${data.title}`}
        >
          {data.lists.map((list, index) => (
            <li
              key={index}
              className="pricing-card-list"
              aria-label={`Feature: ${list.title}`}
            >
              <FaCheckCircle className="pricing-card-icon" />
              <p>
                {list.title}
                {list.description && (
                  <span className="text-grey"> – {list.description}</span>
                )}
              </p>
            </li>
          ))}
        </ul>
      </div>

      <div className="offer-image-container">
        <img
          src={data.img}
          alt={`${data.title} ${data.title_h} illustration`}
          className="offer-image"
          loading="lazy"
        />
      </div>
    </section>
  );
}

export default WeOffer;
